import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators, } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { OptionUpdateText } from '@items/question/items-multiple-choice-single-response/items-multiple-choice-single-response.component';
import { ItemService } from '@services/item.service';
import { NotificationService } from '@services/notification.service';
import { QuestionService } from '@services/question.service';
// import { Editor } from 'ngx-editor';
import { AddNewQuestion, GlobalToolbarConfig, Options, QuestionDescription, } from 'src/app/shared/addnewquestion';
import { CkeditorConfig, ScoringTypeEnum, QuestionSubTypeIdEnum, QuestionTypeIdEnum } from 'src/app/shared/config/questions.config';
import { ItemsSubPartEditorComponent } from '../items-sub-part-editor/items-sub-part-editor.component';
import { RoleManagementService } from '@services/role.management.service';
import { WebErrorService } from '@services/webError.service';
import { TranslateService } from '@ngx-translate/core';
import * as Editor from '../../../../assets/ckeditor';
import { MatSnackBar } from '@angular/material/snack-bar';
import Adapter from '../ckeditorAdapter';
export interface DialogData {
  animal: string;
  name1: string;
  html: string;
  editor: Editor;
  editors: Editor[];
  option: any;
  editor1: Editor;
}


@Component({
  selector: 'app-items-multiple-choice-true-or-false',
  templateUrl: './items-multiple-choice-true-or-false.component.html',
  styleUrls: ['./items-multiple-choice-true-or-false.component.scss']
})
export class ItemsMultipleChoiceTrueOrFalseComponent implements OnInit, OnDestroy {
  listDisplay;
  itemId: any;
  display: boolean = false;
  que: any;
  // editor1: Editor;
  questionDescription: [];
  set_main_form = false;
  ckeditorConfig = CkeditorConfig;
  isCkeditorLoading: boolean = true;
  ScoringTypeEnum = ScoringTypeEnum;
  // addOptionNew: Options[] = [];
  public uploadedFileNames = [];
  public uploadedFileOptions = [];
  addedOptions: Options[] = [
    {
      answerDescription: {
        description: this.translate.instant('questions.multipleChoice.choice3.true'),
        mediaURL: [''],
        file_name: this.uploadedFileOptions
      },

      answerValid: false,
      arrangeOrder: 0,
      correctPoints: 0,
      modified: false,
      optionId: 1,
      selected: false,
      styleid: 0
    },
    {
      answerDescription: {
        description: this.translate.instant('questions.multipleChoice.choice3.false'),
        mediaURL: [''],
        file_name: this.uploadedFileOptions
      },

      answerValid: false,
      arrangeOrder: 0,
      correctPoints: 0,
      modified: false,
      optionId: 2,
      selected: false,
      styleid: 0
    },
  ];
  shuffleSelectValue: any;
  autoscoring: boolean;
  moreSetting: [];
  opened = false;
  optionDiv = false;
  openedD = false;
  name = 'Angular 6';
  parentData = 1;
  i = 0;
  userForm: FormGroup;
  tabs = [];
  selected = new FormControl(0);
  editorform: FormGroup;
  // editor: Editor;
  // editors: Editor[] = [];
  option: [];
  question: [];
  fetchEditQuetion: any;
  fetchEditOption: any;
  toolbar = GlobalToolbarConfig;
  hideRequiredControl = new FormControl(false);
  floatLabelControl = new FormControl('auto');
  panelOpenState: boolean = false;
  animal: string;
  name1: string;
  html: string;
  questionhtml: any;
  fetchEditQuetion1: any;
  queId: any;
  seteditor = true;
  autoscoreSelectValue: any;
  allowChwckAnsSelectValue: any;
  questionDisplayValue: string;
  getQuestionDisplay: string;

  checkansSelectValue: any;
  checkAnsmaintValue: any;

  miniscoretype: any;
  miniscoretypeMainvalue: any;

  penaltypointselectvalue: any = 0;
  penaltypointMainvalue: any;
  scoringselectvalue: any;
  addnewquestion = new AddNewQuestion();
  addnewquestiondescription = new QuestionDescription();
  setAddOption = true;
  editMode = false;
  submitted = false;
  getscoringtype: any;
  getAllowCheckAns: any;
  saveDataValidation = false;
  checkSelectionOption: any;

  addQuestionScore: any;
  newEvent = 0;
  newEvent1: any;
  scoreArray = [];
  questionscoreF = false;
  arrayForScoreadd = [];
  // defultvalue = 0;
  defultvalueScore = 0;
  itemBankQueId: any;
  @Input() defValue = '0';
  @Output() postCreated = new EventEmitter();
  addQuestionForm: FormGroup;
  saveDisable: boolean = false;
  questionuuuid: any;
  scoringTypeId: any;
  QuestionTypeIdEnum = QuestionTypeIdEnum;
  QuestionSubTypeIdEnum = QuestionSubTypeIdEnum;
  StyleDropdownSettings = {};
  StyleList: any;
  selectedStyle: any;
  QuestionScoringType: any;
  QuestionOrientation: any;
  @ViewChild("myEditor") myEditor: any;
  public Editor: any = Editor;
  errorMessage;
  QuestionImages = []
  imageId: number = 1;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private routerstate: ActivatedRoute,
    public dialog: MatDialog,
    public questionService: QuestionService,
    public itemservice: ItemService,
    public roleSer: RoleManagementService,
    private notificationService: NotificationService,
    private webErrorService: WebErrorService,
    public translate: TranslateService,
    public _snackBar: MatSnackBar
  ) {
   console.log(["TRUE", "FALSE"])
    this.itemBankQueId = sessionStorage.getItem('itemId');
    this.scoringTypeId = sessionStorage.getItem('scoringTypeId');
    // this.itemBankQueId = this.router.getCurrentNavigation()?.extras?.state?.iteBankQueId;
    // this.itemId = this.router.getCurrentNavigation() ?.extras ?.state ?.itemId;
    this.routerstate?.parent?.params?.subscribe((data) => {
      this.itemId = data.id;
    });
    if (sessionStorage.getItem('questionuuId')) {
      this.queId = sessionStorage.getItem('questionuuId');
    } else {
      this.queId = this.router.getCurrentNavigation()?.extras?.state?.queId;
    }
    // this.editMode = this.router.getCurrentNavigation() ?.extras ?.state ?.isEdit;
    this.userForm = fb.group({
      hideRequired: this.hideRequiredControl,
      floatLabel: this.floatLabelControl,
      autoscore: new FormControl(true),
      shuffle: [''],
      scoringTypeMatch: ['true'],
      allowCheckAnswer: ['false'],
      penaltyPoint: [0],
      minimumScoreIfAttempt: [0,Validators.required],
      questionDisplay: ['Vertical', Validators.required],
    });

    // this.userForm = this.fb.group({
    //   optionrows: this.fb.array([
    //     this.createOptionControl()
    //   ],Validators.required)
    // })

    // this.editor = new Editor();
    // this.editor1 = new Editor();

    this.questionService.getQuestionScoringType().subscribe(d => {this.QuestionScoringType = d.data})
    this.questionService.getQuestionOrientation().subscribe(o => {this.QuestionOrientation = o.data})
  }

  onReady(editor) {
    // console.log(this.myEditor);
    // editor.ui
    //   .getEditableElement()
    //   .parentElement.insertBefore(
    //     editor.ui.view.toolbar.element,
    //     editor.ui.getEditableElement()
    //   );
    sessionStorage.setItem('ImageUploadFileSizeErr', 'false');
    sessionStorage.setItem('imageUploadErr', 'false');
    editor.plugins.get('FileRepository').createUploadAdapter = (loader: any) => {
      const adapter = new Adapter(loader, editor.config, this.itemservice);
      this.errorMessage = ''
      adapter.upload().catch((error) => {
        if (error === '') {
          if (sessionStorage.getItem('ImageUploadFileSizeErr') == 'true') {
            this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error');
          }

          if (sessionStorage.getItem('imageUploadErr') == 'true') {
            this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error1');
          }
          // this.itemservice.imageSizeErr.subscribe(x => {
          //   if(x == true) {
          //     this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error');
          //   }
          // });
          // this.itemservice.imageUploadErr.subscribe(x => {
          //   if(x == true) {
          //     this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error1');
          //     // this.itemservice.imageUploadErr.unsubscribe();
          //   }
          // });
        }
      });
      adapter.upload().then(res=>{
        this.uploadedFileNames.push(res.fileName)
        this.QuestionImages.push({"uniqueId": "#image" + this.imageId++ , "imageName": res.fileName, "base64": res.default})
      })
      return adapter;
    }
  }

  validateInput(event, o?, type?) {
    const inputElement = event.target;
    const value = inputElement.value;

    const regex = /^\d{0,4}(\.\d{0,2})?$/;
    const inputVal = inputElement.value.split('.')
    const beforeDecimal = inputVal[0]
    const afterDecimal = inputVal[1]
    console.log('value',value)
    if (!regex.test(value)) {
      inputElement.value = value.slice(0, -1);
      if(type == 'options') o.correctPoints = parseFloat(inputElement.value );
      if(type == 'minimumScore') this.userForm.controls.minimumScoreIfAttempt.setValue(parseFloat(inputElement.value))
      if(beforeDecimal.length == 5 && afterDecimal.length > 1){
        inputElement.value = ''
        if(type == 'options') o.correctPoints = 0;
        if(type == 'minimumScore') this.userForm.controls.minimumScoreIfAttempt.setValue(0)
      }
    }
  }

  onClick(event) {
    if (this.errorMessage && event) this.errorMessage = false;
  }

  createOptionControl(): FormGroup {
    return this.fb.group({
      value: [null, Validators.required],
    });
  }

  ngOnInit(): void {
    this.itemservice.StyleListData.subscribe(e => {this.StyleList = e});

    this.saveDisable = false;
    // this.editor = new Editor();
    // this.editor1 = new Editor();
    this.addQuestionForm = new FormGroup({
      question: new FormControl(
        { value: '', disabled: false },
        Validators.required
      )
    });
    this.checkSelectionOption = this.addedOptions;

    if (this.queId) {
      this.seteditor = true;
      this.editMode = true;
      this.questionService
        .getQuestion(this.itemId, this.queId)
        .subscribe((resdata) => {
          this.questionuuuid = resdata?.data.questionuuId;
          // this.question = resdata.data?.questiondescription?.description;
          this.addQuestionForm.controls['question'].setValue(resdata?.data?.questiondescription?.description);
          this.fetchEditOption = resdata.data?.options;

          // if (this.scoringTypeId == ScoringTypeEnum.On180360Degree) {
          //   this.fetchEditOption.forEach(element => {
          //     element['selectedStyle'] = [{styleId: element.styleid, styleName: this.StyleList.find(d => d.styleId == element.styleid)?.styleName}];
          //     this.selectedStyle = [{styleId: element.styleid, styleName: this.StyleList.find(d => d.styleId == element.styleid)?.styleName}]
          //   });
          // }

          this.addedOptions = this.fetchEditOption;
          this.newEvent = resdata.data?.correctPoints;
          this.arrayForScoreadd = this.addedOptions;
          this.autoscoring = resdata.data?.autoScoring;
          // this.fetchEditOption.modified = true;

          // this.arrayForScoreadd = this.addedOptions;
          // this.fetchEditQuetion1 = data ?.questions[0] ?.questionid;

          this.userForm.setValue({
            hideRequired: this.hideRequiredControl,
            floatLabel: this.floatLabelControl,
            autoscore: resdata.data.autoScoring,
            shuffle: resdata.data.shuffleOption,
            scoringTypeMatch: resdata.data.scoringTypeExactMatch,
            allowCheckAnswer: resdata.data.allowCheckAnswer,
            penaltyPoint: resdata.data.penaltyPoint,
            minimumScoreIfAttempt: resdata.data.minScoreIfAttempt,
            questionDisplay: resdata.data.questiondisplayoptions,
          });
          this.getscoringtype = String(resdata.data.scoringTypeExactMatch);
          this.getQuestionDisplay = String(resdata.data.questiondisplayoptions);
          this.getAllowCheckAns = String(resdata.data.allowCheckAnswer);
        },
        (error) => {
          this.webErrorService.handleAPIErrors(error);
        });
    }

    this.arrayForScoreadd = this.addedOptions;
  }

  omit_special_char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 ||(k >= 48 && k <= 57) ||  k == 46);
  }

  replace2Decimal(event: any, o, type: any){
    let value = event.target.value;
    if (event.key == '.') value = value + event.key;
    if(value == '.') value = "";

    var ponto = value.split('.').length;

    if (ponto > 2) value = value.substr(0, (value.length)-1);

    value = value.replace(/[^0-9.-]/,'');

    if (ponto == 2) value = value.substr(0,(value.indexOf('.')+3));

    if (type == 'options') o.correctPoints = parseFloat(value);
    if (type == 'minimumScore') {
      let num = value.substr(value.length - 1);
      if (num != '.' && value != '') this.userForm.controls.minimumScoreIfAttempt.patchValue(parseFloat(value));
    }
  }

  get optionrows(): FormArray {
    return <FormArray>this.userForm.get('optionrows');
  }

  get f() {
    return this.userForm.controls;
  }

  get o() {
    return this.addQuestionForm.controls;
  }

  addOptionRow(): void {
    // this.editors.push(new Editor());
    this.optionrows.push(this.createOptionControl());
  }

  removeOptionRow(index: any) {
    (this.userForm.get('optionrows') as FormArray).removeAt(index);
    //this.editors.remove(index);
  }

  getRowFormControls(): AbstractControl[] {
    return (<FormArray>this.userForm.get('DyRow')).controls;
  }

  onCheckRadioOption(radiovalue, value) {
    this.arrayForScoreadd.forEach((element) => {
      if (element.answerDescription.description == value) {
        element.answerValid = true;
      } else {
        element.answerValid = false;
      }
      this.addScore(radiovalue);
    });

    this.addedOptions = this.arrayForScoreadd;
  }

  addScore(valueScore) {
    // with type info
    // this.arrayForScoreadd = this.addedOptions;
    // this.newEvent = valueScore.correctPoints

    if (this.arrayForScoreadd) {
      this.scoreArray = [];
      this.arrayForScoreadd.forEach((element) => {
        if (element.answerValid == true) {
          this.scoreArray.push(element.correctPoints);
        }
      });
    }

    this.newEvent = this.scoreArray.reduce(add, 0);
    function add(accumulator, a) {
      return accumulator + a;
    }
    // this.scoreArray = [];
    // this.arrayForScoreadd.forEach((element) => {
    //   this.scoreArray.push(element.correctPoints);
    // });
    // this.newEvent = this.scoreArray.reduce(add, 0);
    // function add(accumulator, a) {
    //   // add score of option
    //   return accumulator + a;
    // }
  }

  onSelectStyle(event, option) {
    if (event.target.value) {
      this.addedOptions.forEach((element) => {
        if (option === element.answerDescription.description) {
          element['styleid'] = parseInt(event.target.value);
        }
      });
    }
  }

  deleteOption(index: any) {
    this.addedOptions.splice(index, 1);
  }
  deleteEditOption(index: any) {
    this.fetchEditOption.splice(index, 1);
  }

  keyPressNumbers(event) {
    var charCode = (event.which) ? event.which : event.keyCode;
    // Only Numbers 0-9
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.TrueOrFalse.errMsg1'), true, 'warn')
      return false;
    } else {
      this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.TrueOrFalse.errMsg1'), true, 'warn')
      return false;
    }
  }


  saveQuestion() {
    this.submitted = true;
    if (this.userForm.invalid) {
      this.saveDataValidation = true;
      return;
    }
    this.addnewquestion = new AddNewQuestion();
    this.addnewquestion.questiondescription = new QuestionDescription();
    let selectetionOptionValue = this.addedOptions.filter(
      (value) => value.answerValid == true
    );

    let selectioIndex = this.addedOptions.findIndex(
      (value) => value.answerValid == true
    );
    this.addnewquestion.itemId = this.itemBankQueId;
    this.questionhtml = this.addQuestionForm.controls['question'].value;
    let rmcharHtml = this.questionhtml;//.replace(/(<([^>]+)>)/ig, '');
    let rmCharSpace = rmcharHtml;//.replace(/^\s+/g, '').replace(/&nbsp;/g,'').trim();
    if (rmCharSpace.length === 0) {
      this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.TrueOrFalse.errMsg2'), true, 'warn')
    }
    else if (selectioIndex < 0 && this.scoringTypeId == ScoringTypeEnum.OnQuestion) {
      this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.TrueOrFalse.errMsg3'), true, 'warn')
    } else {
      if (this.editMode == true) {
        this.questionhtml = this.addQuestionForm.controls['question'].value;
        // this.questionhtml = this.question;
        this.addnewquestion.allowCheckAnswer =
          this.userForm.controls['allowCheckAnswer'].value;
        this.addnewquestion.autoScoring = this.userForm.controls['autoscore'].value;
        if (this.userForm.controls['questionDisplay'].value) {
          this.questionDisplayValue = this.userForm.controls['questionDisplay'].value
          this.addnewquestion.questiondisplayoptions = this.questionDisplayValue;
        }
        this.addnewquestion.shuffleOption =
          this.userForm.controls['shuffle'].value;
        // this.addnewquestion.autoScoring = true;
        // this.addnewquestion.allowCheckAnswer = true;
        this.arrayForScoreadd.forEach((element) => {
          element.modified = true;
        });
        this.addedOptions = this.arrayForScoreadd;
        this.addnewquestion.options = this.addedOptions;
      } else {
        // this.questionhtml = toHTML(this.question);
        this.questionhtml = this.addQuestionForm.controls['question'].value;
        this.autoscoreSelectValue = JSON.parse(
          this.userForm.controls['autoscore'].value
        );
        this.addnewquestion.autoScoring = this.autoscoreSelectValue;

        if (this.userForm.controls['allowCheckAnswer'].value) {
          this.allowChwckAnsSelectValue = JSON.parse(
            this.userForm.controls['allowCheckAnswer'].value
          );
          this.addnewquestion.allowCheckAnswer = this.allowChwckAnsSelectValue;
        }
        if (this.userForm.controls['questionDisplay'].value) {
          this.questionDisplayValue = this.userForm.controls['questionDisplay'].value
          this.addnewquestion.questiondisplayoptions = this.questionDisplayValue;
        }
        this.addnewquestion.options = this.addedOptions;
        this.addnewquestion.shuffleOption =
          this.userForm.controls['shuffle'].value;
      }

      this.addnewquestion.correctPoints = this.newEvent;
      // this.addnewquestion.options = this.addedOptions;

      if (this.QuestionImages.length > 0) {
        this.QuestionImages.forEach(ele => {

          rmCharSpace = rmCharSpace.replace(ele.base64, ele.uniqueId)

          let startIndex = ele.base64.lastIndexOf('base64,');
          ele.base64 = ele.base64.substring(startIndex +7)
        })
      }
      this.addnewquestion.questiondescription.description = rmCharSpace;
      this.addnewquestion.questionImages = this.QuestionImages;

      this.addnewquestion.scoringTypeExactMatch = true;

      this.addnewquestion.active = true;
      this.addnewquestion.ansRenderCount = 0;

      this.addnewquestion.questiondescription.mediaURL = ['String'];
      this.addnewquestion.questiondescription.file_name = this.uploadedFileNames;
      this.addnewquestion.questionOrder = 0;
      this.addnewquestion.questionSubTypeId = QuestionSubTypeIdEnum.MultipleChoiceYesOrNo;
      this.addnewquestion.questionTypeId = QuestionTypeIdEnum.MultipleChoiceYesOrNo;
      // this.addnewquestion.shuffleOption = true;
      // this.addnewquestion.shuffleOptions = true;
      // this.autoscoreSelectValue = JSON.parse(this.userForm.controls['autoscore'].value);
      // this.addnewquestion.autoScoring = this.autoscoreSelectValue;

      // this.allowChwckAnsSelectValue = JSON.parse(this.userForm.controls['allowCheckAnswer'].value);
      // this.addnewquestion.allowCheckAnswer = this.allowChwckAnsSelectValue;

      // this.checkansSelectValue = this.userForm.controls['checkAnswerAttempt'].value;
      // this.checkAnsmaintValue = +this.checkansSelectValue;
      // this.addnewquestion.checkAnswerAttempt = this.checkAnsmaintValue;

      this.miniscoretype =
        this.userForm.controls['minimumScoreIfAttempt'].value;
      this.miniscoretypeMainvalue = +this.miniscoretype;
      this.addnewquestion.minScoreIfAttempt = this.miniscoretypeMainvalue;

      // this.addnewquestion.options = this.addOptionNew;

      this.penaltypointselectvalue =
        this.userForm.controls['penaltyPoint'].value;



      // this.penaltypointMainvalue = +this.miniscoretype;
      this.addnewquestion.penaltyPoints = this.penaltypointselectvalue;

      if (this.scoringTypeId == ScoringTypeEnum.OnOption) {
        this.addnewquestion.questionSubTypeId = QuestionSubTypeIdEnum.scoringType_MultipleChoiceYesOrNo;
        this.addnewquestion.questionTypeId = QuestionTypeIdEnum.multichoice_score_option;

        // for (let o of this.addnewquestion.options) {
        //   if (o.correctPoints === 0) {
        //     this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.TrueOrFalse.errMsg4'), true, 'warn') // Used to display alert message
        //     return;
        //   }
        // }
      }

      if (this.scoringTypeId == ScoringTypeEnum.On180360Degree) {
        let valueArr = this.addnewquestion.options.map(function(item){ return item['styleid'] });

        if (!(valueArr.includes(0) || valueArr.includes(undefined))) {
          let isDuplicate = valueArr.some(function(item, idx){
            return valueArr.indexOf(item) != idx
          });

          if (isDuplicate) {
            this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.TrueOrFalse.errMsg5'), true, 'warn') // Used to display alert message
            return;
          }
        } else {
          this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.TrueOrFalse.errMsg6'), true, 'warn') // Used to display alert message
          return;
        }

        this.addnewquestion.questionSubTypeId = QuestionSubTypeIdEnum.style_MultipleChoiceYesOrNo;
        this.addnewquestion.questionTypeId = QuestionTypeIdEnum.styleType_options;
      }

      if (this.editMode == false) {
        if (this.questionhtml == '<p></p>') {
          this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.TrueOrFalse.errMsg2'), true, 'warn')
        }
        else {
          this.questionService
            .addQuestion(this.addnewquestion, this.itemId)
            .subscribe(
              (resData) => {
                this.saveDisable = true;
                // this._snackBar.open(resData?.message, '', { duration: 1000, horizontalPosition: 'right', verticalPosition: 'top', panelClass: ['notification', 'success'] });
                this.notificationService.success(resData?.message); // This line used to display message
                // this.itemservice.questionCountUpdate.next(true);
                // this.questionService.reloadList.next(true);
                this.listDisplay = true;

                // this.back();
              },
              (error) => {
                this.webErrorService.handleAPIErrors(error, null, true, 'warn');
              });
        }
      }

      // for Edit Quetion
      if (this.editMode == true) {
        if (this.questionhtml == '<p></p>') {
          this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.TrueOrFalse.errMsg2'), true, 'warn')
        }
        else {
          this.questionService
            .updateQuestion(this.addnewquestion, this.itemId, this.queId)
            .subscribe(
              (resData) => {
                this.itemservice.editedGetItem(resData.data);
                // this._snackBar.open(resData?.message, '', { duration: 1000, horizontalPosition: 'right', verticalPosition: 'top', panelClass: ['notification', 'success'] });
                this.notificationService.success(resData?.message); // This line used to display message
                // this.itemservice.questionCountUpdate.next(true);
                // this.questionService.reloadList.next(true);
                this.listDisplay = true;

                // this.back();
              },
              (error) => {
                this.webErrorService.handleAPIErrors(error, null, true, 'warn');
              });
        }
      }
    }
  }

  clickData() {
    this.set_main_form = true;
  }

  openOptionDiv() {
    this.setAddOption = false;
    this.optionDiv = true;
  }

  // deleteOption(index1) {
  //   this.addedOptions.splice(index,1);
  // }

  ngOnDestroy(): void {
    if (sessionStorage.getItem('questionuuId')) {
      this.queId = sessionStorage.removeItem('questionuuId');
      sessionStorage.removeItem('questionId');
      sessionStorage.removeItem('questionuuId');
    }
    // this.editors.forEach(item => {
    //   item.destroy();
    // });
  }

  changeFromChild(): void {
    this.parentData = +1;
  }

  data: any;

  openDynamic(index: any) {
    this.data = index;
    if (this.data == index) {
      this.openedD = true;
    } else {
      this.openedD = false;
    }
  }

  onCkeditorReady() {
    this.isCkeditorLoading = false;
  }

  back() {
    // if (this.editMode) {
    //   // this.router.navigate(['../'], { relativeTo: this.routerstate });
    //   this.postCreated.emit('false');
    // } else {
    //   this.postCreated.emit('false');
    // }
    this.postCreated.emit('false');
    this.display = true;
    // this.editor.destroy();
  }

  openDialog(optionData: any, optionId: number): void {
    const dialogSubscription = this.dialog.open(ItemsSubPartEditorComponent,
      { width: '950px', height: '350px', panelClass: 'option-dialog', data: { value: optionData } })
      .afterClosed().subscribe((result) => {
        if (result) {
          var optionUpdateText = new OptionUpdateText();
          optionUpdateText.oldValue = optionData;
          optionUpdateText.newValue = result;
          optionUpdateText.optionIdDia = optionId;
          this.questionService.getUpdateEditValue(optionUpdateText);
        }
        dialogSubscription.unsubscribe();
      });

  }
}
